import React from "react";
import { Button } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import {
  AntInput,
  AntInputPassword,
} from "../../../../components/atoms/AntField";
import { LoginSchema } from "../../../../system/helpers/validation";
import { useNavigate } from "react-router-dom";
import { APP_ROUTES } from "../../../../system/router/constants";

const LoginForm: React.FC<any> = ({ onSubmit }) => {
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validateOnBlur: false,
    validationSchema: LoginSchema,
    onSubmit: onSubmit,
  });

  const { values, submitCount, isValid, handleChange, handleBlur } = formik;

  const submitForm = (e) => {
    e.preventDefault();
    formik.handleSubmit();
  };

  const onLoginViaSSO = () => navigate(APP_ROUTES.dashboard);

  return (
    <FormikProvider value={formik}>
      <form onSubmit={submitForm} className="login-form-container">
        <Field
          component={AntInput}
          name="email"
          type="email"
          placeholder="Email"
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
          submitCount={submitCount}
        />
        <Field
          component={AntInputPassword}
          name="password"
          type="password"
          placeholder="Password"
          value={values.password}
          onChange={handleChange}
          onBlur={handleBlur}
          submitCount={submitCount}
        />
        <Button
          type="primary"
          htmlType="submit"
          disabled={!isValid}
          size="large"
          className="login-form-submit"
        >
          Log into Hub
        </Button>
        <Button
          type="dashed"
          htmlType="button"
          size="large"
          className="login-form-submit"
          onClick={onLoginViaSSO}
        >
          Login via SSO
        </Button>
      </form>
    </FormikProvider>
  );
};

export default LoginForm;
